import { render, staticRenderFns } from "./choose-list.vue?vue&type=template&id=4da21f90&"
import script from "./choose-list.vue?vue&type=script&lang=js&"
export * from "./choose-list.vue?vue&type=script&lang=js&"
import style0 from "./choose-list.vue?vue&type=style&index=0&id=4da21f90&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports